import { TabStoreProvider } from '@/stores/tab/tab-provider';
import { UserStoreProvider } from '@/stores/user/user-provider';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

export default function RouteProviders({ children }: { children: React.ReactNode }) {
  return (
    <NuqsAdapter>
      <UserStoreProvider>
        <TabStoreProvider>{children}</TabStoreProvider>
      </UserStoreProvider>
    </NuqsAdapter>
  );
}
